var jwcounter = 1;
function jwPlayerComponent() {
    document.querySelectorAll('.player-jw').forEach(el => {
        let elId = 'player-jw-' + (jwcounter++);
        el.setAttribute('id', elId)
        var setupObj = {
            file : el.dataset.m3u8,
            image : el.dataset.poster,
        };
        if(el.dataset.title){
            setupObj['title'] = el.dataset.title;
        }
        if(el.dataset.mediaid){
            setupObj['mediaid'] = el.dataset.mediaid;
            setupObj['ga'] = {
                label : 'mediaid'
            };
        }
        if(el.dataset.playerlogo != null){
            if(el.dataset.playerlogo == 0){
                setupObj['logo'] = false;
            }
        }

        if(el.dataset.vertical){
            // setupObj['width'] = "50%";
            setupObj['aspectratio'] = "9:16";
        }
        jwplayer(elId).setup(setupObj);
    })
}

export default jwPlayerComponent;